import { useEffect, useRef, useState } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/app/id6736533773';
const DEEP_LINK_SCHEME = 'chartai://';
const REDIRECT_DELAY_MS = 1500;

function detectIOS(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent;
  const iosUserAgent = /iPhone|iPad|iPod/.test(userAgent);
  const macWithTouch = userAgent.includes('Macintosh') && navigator.maxTouchPoints > 0;

  return iosUserAgent || macWithTouch;
}

interface UseIOSRedirectResult {
  isIOS: boolean;
  wasRedirected: boolean;
}

export function useIOSRedirect(): UseIOSRedirectResult {
  const [isIOS] = useState(() => detectIOS());
  const [wasRedirected, setWasRedirected] = useState(false);
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (!isIOS || redirectedRef.current) {
      return;
    }

    redirectedRef.current = true;
    setWasRedirected(true);

    window.location.href = DEEP_LINK_SCHEME;

    const timeoutId = window.setTimeout(() => {
      window.location.href = APP_STORE_URL;
    }, REDIRECT_DELAY_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isIOS]);

  return { isIOS, wasRedirected };
}
